import { PdfViewerToolbarButton } from '../../PdfViewerToolbarButton'

import {
  PDF_VIEWER_TOOLBAR_SEARCH_ICON_PROPS,
  QA_NAME_PDF_VIEWER_TOOLBAR_SEARCH_BTN,
} from './PdfViewerToolbarSearchTool.constants'

function PdfViewerToolbarSearchTool({ isSearchOpen, onToggleSearch }) {
  return (
    <PdfViewerToolbarButton
      iconProps={PDF_VIEWER_TOOLBAR_SEARCH_ICON_PROPS}
      isActive={isSearchOpen}
      qaName={QA_NAME_PDF_VIEWER_TOOLBAR_SEARCH_BTN}
      titleKey='PdfViewer.SearchBtnKey'
      onClick={onToggleSearch}
    />
  )
}

export default PdfViewerToolbarSearchTool
